/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CopyIcon = /*#__PURE__*/ createSvgIcon(
  'CopyIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M7.5 15c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 016 13.5v-10c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44h8c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v10c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-8zm0-1.5h8v-10h-8v10zm-3 4.5c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 013 16.5V5.75c0-.213.071-.39.214-.534A.72.72 0 013.746 5c.21 0 .39.072.535.216a.72.72 0 01.219.534V16.5h8.75c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H4.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CopyIcon;
